<template>
  <div>
    <!-- 公司简介 -->
    <div class="cpy_info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <center>
            <h4>{{contentData.title}}</h4>
          </center>
        </div>
        <div v-html="contentData.content" class="text item">
        </div>
      </el-card>
    </div>

  </div>
</template>
<script>
export default {
    data: function() {
        return {
            contentId:this.$route.query.contentId || 0,
            contentData:{}
        }
    },
    created: function() {
      this.initData();
    },
    methods: {
      initData(){
        var self = this;

        this.$http.get(self.globalUrl.cpyResultFind+self.contentId).then(function(res) {
            if (res.data.code == 200000) {
                self.contentData = res.data.data;
            }
        });

      },

    }
}
</script>
<style media="screen" lang="less">


.cpy_info{
  margin-top: 2px;
}


</style>



// WEBPACK FOOTER //
// cpyResultContent.vue?5ac0afdb